(() => {
  'use strict';
  const root = document.getElementById('b91-shopping');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const labels = JSON.parse(root.querySelector('[data-b91-labels]').textContent);
  const key = 'bazar91_compare_v1';
  const valid = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(value);
  const clean = value => Array.isArray(value) ? [...new Set(value.filter(valid))].slice(0, 4) : [];
  let selected = [];
  let storageWorks = true;
  try { selected = clean(JSON.parse(localStorage.getItem(key) || '[]')); } catch { storageWorks = false; }
  const comparison = document.getElementById('b91-compare-dialog');
  const sharing = document.getElementById('b91-share-dialog');
  const output = root.querySelector('[data-b91-comparison]');
  const status = root.querySelector('.b91-shopping-status');
  const tray = root.querySelector('.b91-compare-tray');
  let timer;
  let renderVersion = 0;
  let shareData;
  const base = root.dataset.root.replace(/\/?$/, '/');
  const productURL = handle => base + 'products/' + encodeURIComponent(handle);
  function announce(message) {
    clearTimeout(timer);
    status.textContent = message;
    timer = setTimeout(() => { status.textContent = ''; }, 4500);
  }
  function sync() {
    document.querySelectorAll('[data-b91-compare]').forEach(button => {
      const active = selected.includes(button.dataset.b91Compare);
      button.hidden = false;
      button.setAttribute('aria-pressed', String(active));
      button.querySelector('[data-b91-compare-label]').textContent = active ? labels.selected : labels.compare;
    });
    document.querySelectorAll('[data-b91-share]').forEach(button => { button.hidden = false; });
    tray.hidden = !selected.length;
    root.querySelector('[data-b91-count]').textContent = selected.length;
  }
  function save() {
    try { localStorage.setItem(key, JSON.stringify(selected)); } catch { storageWorks = false; }
    sync();
  }
  function node(tag, text, className) {
    const el = document.createElement(tag);
    if (text !== undefined) el.textContent = text;
    if (className) el.className = className;
    return el;
  }
  function action(text, attr, value = '') {
    const el = node('button', text, 'b91-action');
    el.type = 'button';
    el.setAttribute(attr, value);
    return el;
  }
  function show(dialog) {
    if (!dialog.open) dialog.showModal();
  }
  async function load(handle) {
    const response = await fetch(productURL(handle) + '.js', { credentials: 'same-origin', signal: AbortSignal.timeout(12000), cache: 'no-store' });
    if (!response.ok) throw new Error('Product unavailable');
    const product = await response.json();
    if (!product || !Array.isArray(product.variants) || !product.title) throw new Error('Invalid product');
    const spec = new Map();
    const doc = new DOMParser().parseFromString(product.description || '', 'text/html');
    doc.querySelectorAll('table tr').forEach(row => {
      const cells = row.querySelectorAll('th,td');
      if (cells.length !== 2) return;
      const title = cells[0].textContent.trim().replace(/\s+/g, ' ');
      const value = cells[1].textContent.trim().replace(/\s+/g, ' ');
      if (title && value && title.length < 90 && value.length < 400 && spec.size < 30) spec.set(title.toLowerCase().replace(/[:\s]+$/g, ''), { title, value });
    });
    try {
      const response = await fetch(productURL(handle) + '?section_id=bazar91-comparison-data', { credentials: 'same-origin', signal: AbortSignal.timeout(12000), cache: 'no-store' });
      if (!response.ok) throw new Error('Details unavailable');
      const detailDoc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const payload = detailDoc.querySelector('[data-b91-product-specs]');
      if (payload) {
        const details = JSON.parse(payload.textContent);
        if (details.handle !== handle) throw new Error('Product mismatch');
        if (details.brand) product.vendor = details.brand;
        if (details.type) product.type = details.type;
        const verified = new Map();
        String(details.specifications || '').split(/\r?\n/).forEach(line => {
          const separator = line.indexOf(':');
          if (separator < 1) return;
          const title = line.slice(0, separator).trim();
          const value = line.slice(separator + 1).trim();
          if (title && value && title.length < 90 && value.length < 2000 && verified.size < 45) verified.set(title.toLowerCase(), { title, value });
        });
        if (verified.size) { spec.clear(); verified.forEach((value, key) => spec.set(key, value)); }
      }
    } catch {}
    return { handle, product, spec };
  }
  function money(value) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: root.dataset.currency }).format(Number(value) / 100);
  }
  async function render() {
    const version = ++renderVersion;
    output.replaceChildren(node('p', selected.length ? labels.loading : labels.empty));
    if (!selected.length) return;
    const handles = selected.slice();
    const results = await Promise.all(handles.map(handle => load(handle).catch(() => ({ handle, error: true }))));
    if (version !== renderVersion) return;
    const scroll = node('div', undefined, 'b91-comparison-scroll');
    scroll.tabIndex = 0;
    scroll.setAttribute('role', 'region');
    scroll.setAttribute('aria-label', labels.compare_products);
    const table = node('table', undefined, 'b91-comparison-table');
    table.style.minWidth = 150 + results.length * 230 + 'px';
    const cols = node('colgroup');
    const firstCol = node('col'); firstCol.style.width = '150px'; cols.append(firstCol); table.append(cols);
    const head = node('thead');
    const heading = node('tr');
    const corner = node('th', labels.detail); corner.scope = 'col'; heading.append(corner);
    results.forEach(item => {
      const cell = node('th'); cell.scope = 'col';
      if (!item.error && item.product.featured_image) {
        try {
          const url = new URL(item.product.featured_image, location.origin);
          if (url.protocol === 'https:') {
            url.searchParams.set('width', '240');
            const img = node('img'); img.src = url.href; img.alt = item.product.title; img.width = 120; img.height = 120; cell.append(img);
          }
        } catch {}
      }
      const link = node('a', item.error ? item.handle : item.product.title); link.href = productURL(item.handle); cell.append(link);
      if (item.error) { cell.append(node('p', labels.unavailable)); cell.append(action(labels.retry, 'data-b91-retry')); }
      cell.append(action(labels.remove, 'data-b91-remove', item.handle));
      heading.append(cell);
    });
    head.append(heading); table.append(head);
    const body = node('tbody');
    function row(title, getValue) {
      const tr = node('tr'); const th = node('th', title); th.scope = 'row'; tr.append(th);
      results.forEach(item => tr.append(node('td', item.error ? '—' : getValue(item) || labels.not_listed)));
      body.append(tr);
    }
    row(labels.price, ({product:p}) => p.price_min !== p.price_max ? money(p.price_min) + ' – ' + money(p.price_max) : money(p.price));
    row(labels.brand, ({product:p}) => p.vendor);
    row(labels.category, ({product:p}) => p.type);
    row(labels.availability, ({product:p}) => p.available ? labels.available : labels.sold_out);
    row(labels.sku, ({product:p}) => [...new Set(p.variants.map(v => v.sku).filter(Boolean))].join(', '));
    row(labels.variants, ({product:p}) => String(p.variants.length));
    const specs = new Map();
    results.filter(i => !i.error).forEach(item => item.spec.forEach((v, k) => { if (!specs.has(k) && specs.size < 45) specs.set(k, v.title); }));
    specs.forEach((title,k) => row(title, item => item.spec.get(k)?.value));
    table.append(body); scroll.append(table); output.replaceChildren(scroll);
    if (specs.size) output.append(node('p', labels.spec_hint, 'b91-dialog-intro'));
  }
  function share(button) {
    shareData = { title: button.dataset.title, url: button.dataset.url };
    root.querySelector('[data-b91-share-title]').textContent = shareData.title;
    root.querySelector('#b91-share-url').value = shareData.url;
    const text = shareData.title + '\n' + shareData.url;
    root.querySelector('[data-b91-whatsapp]').href = 'https://wa.me/?text=' + encodeURIComponent(text);
    root.querySelector('[data-b91-email]').href = 'mailto:?subject=' + encodeURIComponent(shareData.title) + '&body=' + encodeURIComponent(text);
    root.querySelector('[data-b91-native]').hidden = typeof navigator.share !== 'function';
    root.querySelector('[data-b91-copy-status]').textContent = '';
    show(sharing);
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-b91-compare],[data-b91-share],[data-b91-open-compare],[data-b91-clear],[data-b91-close],[data-b91-remove],[data-b91-retry],[data-b91-copy],[data-b91-native]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (button.hasAttribute('data-b91-compare')) {
      const handle = button.dataset.b91Compare;
      if (!valid(handle)) return;
      if (selected.includes(handle)) { selected = selected.filter(h => h !== handle); announce(labels.removed); }
      else if (selected.length >= 4) { announce(labels.limit); return; }
      else { selected.push(handle); announce(labels.added); }
      save();
      if (!storageWorks) announce(labels.storage);
    } else if (button.hasAttribute('data-b91-open-compare')) { show(comparison); render(); }
    else if (button.hasAttribute('data-b91-clear')) { selected = []; save(); if (comparison.open) render(); }
    else if (button.hasAttribute('data-b91-remove')) { selected = selected.filter(h => h !== button.dataset.b91Remove); save(); render(); }
    else if (button.hasAttribute('data-b91-retry')) render();
    else if (button.hasAttribute('data-b91-close')) button.closest('dialog').close();
    else if (button.hasAttribute('data-b91-share')) share(button);
    else if (button.hasAttribute('data-b91-copy')) {
      try { await navigator.clipboard.writeText(shareData.url); root.querySelector('[data-b91-copy-status]').textContent = labels.copied; }
      catch { const input = root.querySelector('#b91-share-url'); input.focus(); input.select(); root.querySelector('[data-b91-copy-status]').textContent = labels.copy_fallback; }
    } else if (button.hasAttribute('data-b91-native')) {
      try { await navigator.share(shareData); } catch (error) { if (error.name !== 'AbortError') root.querySelector('[data-b91-copy-status]').textContent = labels.copy_fallback; }
    }
  }, true);
  window.addEventListener('storage', event => {
    if (event.key !== key) return;
    try { selected = clean(JSON.parse(event.newValue || '[]')); } catch { selected = []; }
    sync(); if (comparison.open) render();
  });
  const observer = new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(n => n.nodeType === 1 && (n.matches('[data-b91-actions]') || n.querySelector('[data-b91-actions]'))))) sync();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  sync();
})();
